<template>
  <div class="d-flex">
    <b-card class="my-2 w-100">
      <div class="d-flex flex-wrap">
        <h4>Список предметов ЕГЭ</h4>
        <b-button
          variant="primary"
          @click="onAddExam"
          class="d-block ml-auto"
        >
          Добавить
        </b-button>
      </div>
      <div class="ag-grid-olympics-list mt-2" ref="gridDiv">
        <ag-grid-vue
          class="ag-theme-material h-100"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="rowData"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
        >
        </ag-grid-vue>
      </div>
    </b-card>
    <DeleteModal
      id="deleteExamModal"
      title="Подтверждение удаления предмета ЕГЭ"
      @delete="onDeleteConfirm"
    >
      {{ deleteText }}
    </DeleteModal>
    <EditExamsModal :editData="selected" @save="onSaveExams" />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { clientWidthType } from '@/config/config'
import AgGridFactory from '@/components/helpers/factory/agGrid'
import DeleteModal from '@/components/ui/modals/DeleteModal.vue'
import EditExamsModal from '@/components/admin/modals/recommendations/EditExamsModal.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'Olympiads',
  components: {
    AgGridVue,
    DeleteModal,
    EditExamsModal
  },
  data() {
    return {
      gridOptions: AgGridFactory.getGridOptionsDefault(),
      columnDefs: [
        {
          headerName: 'Название',
          field: 'name',
          width: 350
        },
        AgGridFactory.getDefaultActionRenderer({
          onEdit: this.onEditClick,
          onDelete: this.onDeleteClick
        })
      ],
      rowData: [],
      gridApi: null,
      deleteText: 'При удалении предмета ЕГЭ будут удалены данные '
        + 'связанные с проходными баллами на направления '
        + 'вузов-партнеров. Вы подтверждаете удаление?',
      selected: null
    }
  },
  async created() {
    await this.updateExams()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridSizeChanged()
      params.api.resetRowHeights()
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.TIGHT) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    async updateExams() {
      const response = await RecommendationAPI.getExamSubjects()
      const filterModel = this.gridOptions.api ? this.gridOptions.api.getFilterModel() : null
      const sortModel = this.gridOptions.api ? this.gridOptions.api.getSortModel() : null
      this.rowData = response.data
      this.$nextTick(() => {
        if (this.gridOptions.api) {
          this.gridOptions.api.setFilterModel(filterModel)
          this.gridOptions.api.setSortModel(sortModel)
        }
      })
    },
    onEditClick(params) {
      this.selected = params
      this.$bvModal.show('editExamModal')
    },
    onDeleteClick(params) {
      this.selected = params
      this.$bvModal.show('deleteExamModal')
    },
    onAddExam() {
      this.selected = null
      this.$bvModal.show('editExamModal')
    },
    async onDeleteConfirm() {
      await RecommendationAPI.deleteExamSubject(this.selected.id)
      await this.updateExams()
    },
    async onSaveExams(params) {
      if (params.id) {
        await RecommendationAPI.updateExamSubject(params)
      } else {
        await RecommendationAPI.addExamSubject(params.name)
      }
      await this.updateExams()
    }
  }
}
</script>

<style scoped>
.ag-grid-olympics-list {
  height: calc(100vh - 230px);
}
</style>
